import Icons from 'app/src/kit/Icons'
import MapMarkerOutline, {
  DEFAULT_MARKER_SIZE_IN_PX,
  SMALL_MARKER_SIZE_IN_PX
} from 'app/src/map/MapMarkerOutline'
import { useTheme } from 'styled-components'

interface RestrictedMarkerProps {
  lat: number
  lng: number
  isFocused?: boolean
  kind?: 'plot' | 'station'
  onClick: () => void
}

const RestrictedMarker = ({
  lat,
  lng,
  kind = 'plot',
  isFocused,
  onClick,
  ...other
}: RestrictedMarkerProps) => {
  const { radiuses } = useTheme()
  return (
    <MapMarkerOutline
      $lat={lat}
      $lng={lng}
      onClick={onClick}
      {...other}
      $backgroundColor={'grayscale.black'}
      $isFocused={isFocused ?? false}
      $borderRadius={kind === 'plot' ? radiuses.xxl : radiuses.md}
      $size={kind === 'plot' ? DEFAULT_MARKER_SIZE_IN_PX : SMALL_MARKER_SIZE_IN_PX}
    >
      <Icons.Lock $color={'grayscale.white'} $size='lg' />
    </MapMarkerOutline>
  )
}

export default RestrictedMarker
